import { formatPath } from "./util";
var AxiosCache = /** @class */ (function () {
    function AxiosCache() {
        this.cacheList = {};
    }
    AxiosCache.prototype.setCache = function (config, response) {
        if (config.method === 'GET' || config.method === 'get') {
            var path = formatPath(config.url, config.params);
            this.cacheList[path] = {
                data: response,
                timeStamp: new Date().getTime()
            };
        }
    };
    AxiosCache.prototype.getCache = function (config) {
        var timeStamp = new Date().getTime();
        var path = formatPath(config.url, config.params);
        var data = this.cacheList[path];
        if (data) {
            if ((timeStamp - data.timeStamp < 500)) {
                return data.data;
            }
            else {
                delete this.cacheList[path];
            }
        }
        return null;
    };
    return AxiosCache;
}());
export { AxiosCache };



//////////////////
// WEBPACK FOOTER
// ./src/utils/axios.cache.ts
// module id = 482
// module chunks = 41